export const Index = r => require.ensure([], () => r(require('./index')), 'home-bundle');

export default [
  {
    path: 'home',
    name: 'home',
    component: Index
  }
];
